import React, { useEffect, useRef, useState } from "react";
import {
  Truck,
  ShieldCheck,
  Gift,
  RotateCcw,
  BookOpen,
  Users,
  Calendar,
  Award
} from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useLayout } from "../../contexts/LayoutContext";
import { resolveFeatureSections } from "../../utils/featureSections";
import "./FeaturesBanner.css";

// Features for Products (E-commerce)
const productFeatures = [
  {
    Icon: Truck,
    title_en: "Fast Delivery",
    title_ar: "شحن سريع",
    desc_en: "24-48 hours delivery",
    desc_ar: "توصيل خلال 24-48 ساعة",
  },
  {
    Icon: ShieldCheck,
    title_en: "Secure Payment",
    title_ar: "دفع آمن",
    desc_en: "100% purchase protection",
    desc_ar: "100% حماية مشترياتك",
  },
  {
    Icon: Gift,
    title_en: "Daily Offers",
    title_ar: "عروض يومية",
    desc_en: "Exclusive discounts daily",
    desc_ar: "خصومات حصرية كل يوم",
  },
  {
    Icon: RotateCcw,
    title_en: "Easy Returns",
    title_ar: "إرجاع سهل",
    desc_en: "30-day flexible return",
    desc_ar: "سياسة إرجاع مرنة 30 يوم",
  },
];

// Features for Services (Courses, Consultations, Freelancers)
const servicesFeatures = [
  {
    Icon: BookOpen,
    title_en: "Learn Anytime",
    title_ar: "تعلم في أي وقت",
    desc_en: "Flexible learning schedules",
    desc_ar: "جداول تعليمية مرنة",
  },
  {
    Icon: ShieldCheck,
    title_en: "Certified Experts",
    title_ar: "خبراء معتمدون",
    desc_en: "Verified professional instructors",
    desc_ar: "مدربون محترفون معتمدون",
  },
  {
    Icon: Users,
    title_en: "Live Support",
    title_ar: "دعم مباشر",
    desc_en: "Expert guidance available",
    desc_ar: "إرشادات من الخبراء متاحة",
  },
  {
    Icon: Award,
    title_en: "Get Certified",
    title_ar: "احصل على شهادة",
    desc_en: "Completion certificates",
    desc_ar: "شهادات إتمام معترف بها",
  },
];

export default function FeaturesBanner() {
  const { lang } = useLanguage();
  const { settings, loadingSettings } = useLayout();
  const isAr = lang === "ar";
  const sections = resolveFeatureSections(settings || {});

  // اختر الـ features بناءً على ما إذا كانت Products معطلة
  const features = sections?.products ? productFeatures : servicesFeatures;
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`features-banner ${visible ? "is-visible" : ""}`}
      dir={isAr ? "rtl" : "ltr"}
    >
      {features.map(({ Icon, title_en, title_ar, desc_en, desc_ar }, i) => (
        <div
          className="feature-item"
          key={i}
          style={{ "--delay": `${i * 120}ms` }}
        >
          <div className="feature-icon-wrapper">
            <Icon size={28} strokeWidth={1.5} />
          </div>
          <h4>{isAr ? title_ar : title_en}</h4>
          <p>{isAr ? desc_ar : desc_en}</p>
        </div>
      ))}
    </section>
  );
}
